module.exports = __webpack_public_path__ + "img/product9.1717f75c.png";